import React, { Component } from 'react';
import numeral from 'numeral';
import Button from 'material-ui-beta/Button';
import Switch from 'material-ui-beta/Switch';

import './ShoppingCartItem.css';

class ShoppingCartItem extends Component {

    onAutoRenewChecked = () => {
        this.props.item.autoRenew = !this.props.item.autoRenew;
        this.setState({});
    };

    render() {
        console.log(this.props.item);
        return (
            <div className="cart-item-container">
                <div className="flex">
                    <div className="flex1">
                        <div className="cart-item-title oswald">
                            {this.props.item.resource.title}
                        </div>
                        <div className="cart-item-subtitle lato">
                            {this.props.item.resource.pricing[this.props.item.selectedOption].title}
                        </div>
                    </div>
                    <div className="cart-item-total lato">
                        {numeral(this.props.item.getTotal() / 100.0).format('$0,0.00')}
                    </div>
                </div>
                {this.props.item.locations ?
                    <div className="cart-item-locations oswald">
                        {this.props.item.locations.map(location => { return location.name }).join(" • ")}
                    </div>
                    :
                    null
                }
                <div className="cart-item-auto-renew-container flex">
                    <div>
                        <div className="cart-item-auto-renew-title lato">
                            Auto-renew Purchase?
                        </div>
                        <div className="cart-item-auto-renew-description lato">
                            We will charge the same Card used today every time this purchase expires.
                        </div>
                    </div>
                    <div>
                        <Switch
                            checked={this.props.item.autoRenew}
                            onChange={this.onAutoRenewChecked}
                            value="checked" />
                    </div>
                </div>
                <div className="cart-item-remove-btn-container">
                    <Button color="secondary" onClick={this.props.onRemoveClick}>Remove From Cart</Button>
                </div>
            </div>
        )
    }

}

export default ShoppingCartItem;


// WEBPACK FOOTER //
// ./src/components/admin-shopping-cart/ShoppingCartItem.js